// Die Projektaktionen der Kopfzeile (Referenz: docs/design/01-roadmap-expanded.png).
//
// WOFUER: diese Knoepfe sassen im hohen „Hero"-Kasten der Projektseite, dem
// zweiten von ACHT Baendern ueber der ersten Aufgabenzeile. Sie ziehen als
// `actions` in die EINE App-Kopfzeile (`usePageHeader`), der Kasten entfaellt.
//
// KEINER darf verloren gehen: „Neu ▾" (ProjectAddMenu), „Projekt
// zusammenfassen" (nur bei aktivierter KI), „Export", „Teilen" (nur
// Owner/Admin), „Einstellungen" (nicht fuer Nur-Lese-Zugriff). Die
// Sichtbarkeits-Bedingungen sind unveraendert uebernommen — nur der Ort ist neu.
//
// Klassenketten sind gegen `components/ui/Button` getauscht (vorher vier
// handgeschriebene, fast gleiche Ketten).

import type { JSX } from "preact";
import { Download, Settings, Sparkles, UserPlus } from "lucide-preact";
import type { ProjectWithCounts } from "@juuplan/shared";
import { Button } from "../../components/ui/Button";
import { ProjectAddMenu } from "../../components/ProjectAddMenu";

export interface ProjectActionsProps {
  project: ProjectWithCounts;
  readOnly: boolean;
  canShare: boolean;
  aiEnabled: boolean;
  aiSummaryBusy: boolean;
  settingsOpen: boolean;
  onSummarize: () => void;
  onExport: () => void;
  onShare: () => void;
  onToggleSettings: () => void;
}

export function ProjectActions(props: ProjectActionsProps): JSX.Element {
  const {
    project,
    readOnly,
    canShare,
    aiEnabled,
    aiSummaryBusy,
    settingsOpen,
    onSummarize,
    onExport,
    onShare,
    onToggleSettings,
  } = props;

  return (
    <div
      class="flex flex-wrap items-center gap-2"
      data-testid="project-actions"
    >
      {!readOnly && <ProjectAddMenu project={project} />}

      {aiEnabled && (
        <Button
          variant="secondary"
          size="sm"
          icon={Sparkles}
          loading={aiSummaryBusy}
          onClick={onSummarize}
          title="Projekt mit KI zusammenfassen (Aufgaben + Kommentare werden an den KI-Anbieter gesendet)"
          aria-label="Projekt mit KI zusammenfassen"
          data-testid="ai-summarize-btn"
        >
          <span class="hidden lg:inline">
            {aiSummaryBusy ? "Wird zusammengefasst…" : "Zusammenfassen"}
          </span>
        </Button>
      )}

      <Button
        variant="secondary"
        size="sm"
        icon={Download}
        onClick={onExport}
        title="Projekt als Excel exportieren"
        aria-label="Projekt als Excel exportieren"
        data-testid="project-action-export"
      >
        <span class="hidden lg:inline">Export</span>
      </Button>

      {canShare && (
        <Button
          variant="secondary"
          size="sm"
          icon={UserPlus}
          onClick={onShare}
          title="Projekt teilen"
          aria-label="Projekt teilen"
          data-testid="project-action-share"
        >
          <span class="hidden lg:inline">Teilen</span>
        </Button>
      )}

      {!readOnly && (
        <Button
          variant="secondary"
          size="sm"
          icon={Settings}
          onClick={onToggleSettings}
          aria-pressed={settingsOpen}
          title="Projekt-Einstellungen"
          aria-label="Projekt-Einstellungen"
          data-testid="project-action-settings"
        >
          <span class="hidden lg:inline">Einstellungen</span>
        </Button>
      )}
    </div>
  );
}
